type PaylineApi = {
  endToken: (
    additionnalData: any,
    callback: (args: any) => any,
    spinner: any,
    handledByMerchant: boolean,
  ) => void;
  finalizeShortCut: (args: any) => any;
  getBuyerShortCut: (args: any) => any;
  getCancelAndReturnUrls: (args: any) => any;
  getContextInfo: (key: string) => any;
  getCssIframeWhiteList: (args: any) => any;
  getFragmentedPaymentInfo: (args: any) => any;
  getLanguage: (args: any) => any;
  getOrderInfos: (args: any) => any;
  getRecurringDetails: (args: any) => any;
  getToken: (args: any) => any;
  getTokenStatus: (
    token: string,
    callback: (tokenStatus: 'ALIVE' | 'EXPIRED' | 'UNKNOWN') => void,
  ) => void;
  hide: () => any;
  init: (args?: any) => any;
  isSandBox: (args: any) => any;
  reset: (token?: string, template?: string) => void;
  show: (args: any) => any;
  toggle: (args: any) => any;
  updateWebpaymentData: (token: string, data: any) => void;
};

declare global {
  interface Window {
    Payline?: { Api: PaylineApi };
  }
}

const usePayline = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  if (!window.Payline) {
    throw new Error(
      'window.Payline is unavailable. Check if PaylineProvider is rendered within the component tree.',
    );
  }

  return window.Payline.Api;
};

export default usePayline;
